module.exports = __webpack_public_path__ + "img/Chat Icon - charcoal.7f292974.svg";